export const decorationScheme = {
    tabs: {
        myScheme: '我的方案({value})',
        collaborationScheme: '协作方案({value})',
    },
    placeholder: {
        name: '请输入方案名称',
    },
    label: {
        name: '方案名称',
        status: '投稿状态',
        timeRange: '时间范围',
        searchButton: '搜索',
    },
    sortType: {
        updateTimeOrder: '按更新时间正序',
        reverseUpdateTimeOrder: '按更新时间倒序',
        createTimeOrder: '按创建时间正序',
        reverseCreateTimeOrder: '按创建时间倒序',
    },
    status: {
        all: '全部',
        submit: '投稿',
        redraft: '重新投稿',
        view: '查看投稿',
        waiting: '待投稿',
        review: '审核中',
        failed: '不通过',
        passed: '通过',
    },
    description: {
        review: '投稿审核中',
        failed: '投稿失败',
    },
    menu: {
        edit: '编辑方案',
        create: '创建项目',
        publish: '公开方案',
        delete: '删除',
        update: '更新方案',
        startCollaboration: '发起协作',
        gotoCollaboration: '去协作',
        dissolveCollaboration: '解散协作',
        exitCollaboration: '退出协作',
    },
    publishConfirm: {
        title: '确认将此方案公开至企业方案中吗？',
        description: '公开后，企业内成员均可查看并下载该方案',
        feedback: '公开至企业成功，可在【企业方案】中查看',
        cancel: '取消',
        confirm: '确认',
    },
    deleteConfirm: {
        title: '确认删除该方案？',
        description:
            '删除后，将同步删除【智能设计端】方案数据，且删除后不可恢复',
        cancel: '取消',
        confirm: '确认',
        multipleTitle: '确认批量删除 {num} 个方案？',
    },
    empty: '暂无项目',
    updateTitle: '确认要更新方案吗？',
    updateWarn: '更新后会覆盖原方案数据，请谨慎操作',
    updateSuccess: '方案更新成功',
    updateFail: '更新失败',
    know: '我知道了',
    mark: '标记为案例',
    cancelMark: '取消标记案例',
    onlyView: '仅看案例',
    notSupported: '选中的案例均不支持此操作',
    multiple: {
        isMarked: '已批量标记为案例',
        isCancel: '已批量取消标记案例',
        none: '未选中案例',
    },
    batchOperation: '批量操作',
    alreadySelect: '已选{value}',
};
